<div *ngIf="theme === 'analytics' || theme === 'analytics-mobile'; else nativeSelect" class="dropdown"
	[ngClass]="'theme-' + theme"
	(click)="showCustomDropdownExpanded = !showCustomDropdownExpanded"
	(clickOutside)="showCustomDropdownExpanded = false">
	{{ displayValue }}
	<div class="dropdown-content" *ngIf="showCustomDropdownExpanded">
		<div *ngFor="let option of options; trackBy: optionTrackBy" class="option" [class.active]="value === option.value"
			(click)="valueChanged(option.value)">
			<div class="icon"><i class="fa" [ngClass]="{ 'fa-check' : value === option.value }"></i></div>
			{{ option.label }}
		</div>
	</div>
</div>

<ng-template #nativeSelect>
	<select [(ngModel)]="value" (ngModelChange)="valueChanged($event)" [ngClass]="'theme-' + theme" [style.opacity]="value ? '1' : (placeholder ? '0' : '1')">
		<option *ngIf="placeholder" value="">{{ placeholder }}</option>
		<ng-container *ngIf="options && options.length">
			<option
				*ngFor="let option of options; trackBy: optionTrackBy"
				[disabled]="option.disabled" [value]="option.value"
				[attr.selected]="value === option.value || null"
			>{{option.label}}</option>
		</ng-container>
		<ng-content></ng-content>
	</select>
</ng-template>

<div class="select-placeholder" *ngIf="!value && placeholder">
	<span>{{ placeholder }}</span>
</div>

<div class="right-button">
	<i class="fa fa-chevron-down"></i>
</div>
